module.exports = __webpack_public_path__ + "img/Home.d2b36049.svg";